/** Who may undo a disposition — the gate ClearedView carried, extracted so
 *  the party page (item 14: the Cleared tab is hidden, reversal moves home)
 *  and any later surface share ONE answer.
 */
import { MANUAL_MATCH } from './resolveRules'
import type { Resolution } from './types'

export interface ReversalFacts {
  machine: boolean
  status: string
  pending: boolean
  resolved_by: string | null
}

/** Reversible: approved, or your own pending submission — and ALWAYS for a
 *  machine match. Undoing a machine decision is not a disposition: nobody
 *  signed for it, so there is no maker whose submission it is and nothing for
 *  a second pair of eyes to re-examine. Requiring approval would make the
 *  machine's mistakes more expensive to undo than a person's. */
export function canReverse(f: ReversalFacts, userId: string | null | undefined): boolean {
  // only a LIVE disposition can be undone. ClearedView never met the other
  // states (its endpoint lists effective ones only) but the party page reads
  // the run's full resolution list — open, rejected and already-requested
  // reversals have nothing left to press, machine or not.
  if (f.status !== 'approved' && f.status !== 'resolved_pending_review') return false
  return (
    f.machine
    || f.status === 'approved'
    || (f.pending && userId != null && f.resolved_by === userId)
  )
}

/** The same facts read off a Resolution row (the party page's shape).
 *  `details.actor` is the server's own machine marker (recon_state.is_machine);
 *  absence means human — every match written before the marker existed was
 *  signed for by a person. */
export function reversalFacts(r: Resolution): ReversalFacts {
  return {
    machine: r.reason_code === MANUAL_MATCH && (r.details?.actor ?? 'human') === 'machine',
    status: r.status,
    pending: r.status === 'resolved_pending_review',
    resolved_by: r.resolved_by,
  }
}
